import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const JobCard = ({ job, onApply }) => {
  const getLocationIcon = (location) => {
    switch (location) {
      case 'Remote':
        return 'Wifi';
      case 'Hybrid':
        return 'Home';
      case 'On-site':
        return 'Building';
      default:
        return 'MapPin';
    }
  };

  const getDepartmentColor = (department) => {
    const colors = {
      'Engineering': 'bg-blue-100 text-blue-600',
      'Marketing': 'bg-purple-100 text-purple-600',
      'Customer Success': 'bg-green-100 text-green-600',
      'Operations': 'bg-orange-100 text-orange-600',
      'Design': 'bg-pink-100 text-pink-600',
      'Sales': 'bg-yellow-100 text-yellow-600'
    };
    return colors[department] || 'bg-gray-100 text-gray-600';
  };

  return (
    <div className="bg-white rounded-xl shadow-soft hover:shadow-medium transition-all duration-300 p-6 border border-border">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
            {job?.title}
          </h3>
          <div className="flex items-center space-x-4 mb-3">
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getDepartmentColor(job?.department)}`}>
              {job?.department}
            </span>
            <div className="flex items-center space-x-1 text-text-secondary">
              <Icon name={getLocationIcon(job?.location)} size={16} />
              <span className="text-sm">{job?.location}</span>
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm text-text-secondary">{job?.type}</p>
          <p className="text-sm font-medium text-primary">{job?.experience}</p>
        </div>
      </div>

      <p className="text-text-secondary mb-4 line-clamp-3">
        {job?.description}
      </p>

      <div className="mb-4">
        <h4 className="font-medium text-text-primary mb-2">Key Requirements:</h4>
        <div className="flex flex-wrap gap-2">
          {job?.requirements?.slice(0, 3).map((req, index) => (
            <span
              key={index}
              className="text-xs bg-surface-100 text-text-secondary px-2 py-1 rounded-md"
            >
              {req}
            </span>
          ))}
          {job?.requirements?.length > 3 && (
            <span className="text-xs text-primary">
              +{job.requirements.length - 3} more
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-1 text-text-secondary">
            <Icon name="Calendar" size={14} />
            <span className="text-xs">Posted {job?.postedDate}</span>
          </div>
          <div className="flex items-center space-x-1 text-text-secondary">
            <Icon name="Users" size={14} />
            <span className="text-xs">{job?.applicants} applicants</span>
          </div>
        </div>
        <Button
          variant="primary"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => onApply?.(job)}
        >
          Apply Now
        </Button>
      </div>
    </div>
  );
};

export default JobCard;